<script setup lang="ts">
/* eslint-disable max-len */
</script>

<template>
  <svg width="16" height="16" viewBox="0 0 13 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.244 15.982a.782.782 0 0 1-.544-.226L6.5 10.72l-5.2 5.063c-.272.283-.756.283-1.058.028a.821.821 0 0 1-.242-.48V.707C0 .311.333 0 .756 0h11.488c.423 0 .756.311.756.707v14.568a.766.766 0 0 1-.756.707z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
